import { DecorationDto } from './decoration-dto';

export class SleeveDto extends DecorationDto { }